var _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSmartMesh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.14 20.112c-2.059-2.04-4.632-3.194-7.293-3.46h-.053a11.92 11.92 0 0 0-7.293 3.46 2.41 2.41 0 0 0 0 3.407c.16.16.337.301.532.39.923.515 2.094.39 2.875-.39a7.142 7.142 0 0 1 3.92-2.005 7.154 7.154 0 0 1 6.264 2.005c.16.16.337.301.533.39.177-.106.355-.23.514-.39a2.41 2.41 0 0 0 0-3.407zm6.795-6.796c-3.921-3.921-8.96-5.997-14.106-6.28a21.469 21.469 0 0 0-14.124 6.28 2.41 2.41 0 0 0 0 3.407c.16.16.337.284.515.373a2.34 2.34 0 0 0 2.874-.373 16.842 16.842 0 0 1 10.717-4.897c4.702-.32 9.493 1.313 13.077 4.897.16.16.337.284.532.39a2.41 2.41 0 0 0 .515-3.797z",
    fill: "url(#ok6k83jwoa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.295 30.314c0 1.615-1.029 2.981-2.484 3.46a3.666 3.666 0 0 1-2.466-3.46 3.666 3.666 0 0 1 2.466-3.46 3.624 3.624 0 0 1 2.484 3.46z",
    fill: "url(#fozgzvjbjb)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.693 11.592c-.692.532-1.349 1.1-1.988 1.721a2.41 2.41 0 0 0 0 3.407c.16.16.337.284.515.372a2.34 2.34 0 0 0 2.874-.372l.107-.107c-1.225-1.33-1.721-3.229-1.508-5.039v.018z",
    fill: "url(#btuvszd10c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.435 18.636c-.692.426-1.349.887-1.952 1.49a2.41 2.41 0 0 0 0 3.407c.16.16.337.302.532.39.888.497 1.97.39 2.75-.301-1.135-1.349-1.578-3.212-1.348-4.986h.018z",
    fill: "url(#kuizsz3lxd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.989 26.958s-.125-.071-.178-.09a3.666 3.666 0 0 0-2.466 3.46 3.666 3.666 0 0 0 2.466 3.46c.284-.088.532-.248.763-.39-1.313-1.81-1.49-4.382-.585-6.423v-.017z",
    fill: "url(#9zks3ykoje)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.094 16.726c6.565-6.565 17.229-6.565 23.794 0a2.41 2.41 0 0 0 3.407-3.407c-8.446-8.428-22.162-8.428-30.59.018a2.41 2.41 0 0 0 3.407 3.406l-.018-.017zm6.796 6.795a7.207 7.207 0 0 1 10.202 0 2.41 2.41 0 0 0 3.407-3.407c-4.684-4.684-12.296-4.684-16.998 0a2.41 2.41 0 0 0 3.407 3.407h-.018z",
    stroke: "url(#k6tpw6ouyf)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.662a3.65 3.65 0 0 1 3.655 3.655A3.65 3.65 0 0 1 20 33.972a3.65 3.65 0 0 1-3.655-3.655A3.65 3.65 0 0 1 20 26.662z",
    stroke: "url(#bh4xevwc9g)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ok6k83jwoa",
    x1: 4,
    y1: 22.584,
    x2: 32.778,
    y2: 12.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fozgzvjbjb",
    x1: 4,
    y1: 22.584,
    x2: 32.778,
    y2: 12.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btuvszd10c",
    x1: 4,
    y1: 24.492,
    x2: 20.25,
    y2: 20.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kuizsz3lxd",
    x1: 4,
    y1: 24.492,
    x2: 20.25,
    y2: 20.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9zks3ykoje",
    x1: 4,
    y1: 24.492,
    x2: 20.25,
    y2: 20.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k6tpw6ouyf",
    x1: 4,
    y1: 22.684,
    x2: 34.554,
    y2: 10.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh4xevwc9g",
    x1: 4,
    y1: 22.684,
    x2: 34.554,
    y2: 10.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSmartMesh);
export default __webpack_public_path__ + "static/media/serviceSmartMesh.f33a0ef7680ea4f91129802cf9631439.svg";
export { ForwardRef as ReactComponent };